import { HUMAN_SERVICE_REPLY } from "../constants/dialogue"
import { EAiAgentType } from "../types/enums/aiEnum"
import { IAICommodityRes, IHouseKeeperRes, ISaleAssistantRes } from "../types/response/resAI"

let residueCon: string = ''

// 返回响应中需要的参数内容
export function getAiAgentResResults(data: string) {

    const res = { session_id: '', result: '', txtFinish: false, finish: false, commodity: [] as IAICommodityRes[], intention: '' as EAiAgentType }

    data = residueCon + data
    residueCon = ''

    const dataArr = data.replaceAll('event:message', '').split('data:').filter(item => item.trim())
    let dataIndex = 0

    while (dataIndex < dataArr.length && !res.finish) {
        const CON = dataArr[dataIndex].trim()

        let resJSON: (IHouseKeeperRes | ISaleAssistantRes)
        try {
            resJSON = JSON.parse(CON)
        } catch (error) {
            residueCon = CON
            break
        }

        // console.log(resJSON)

        // AI 消息处理
        res.intention = (resJSON?.activity_agent || resJSON?.data?.activity_agent) ?? ''
        res.session_id = resJSON.session_id ?? ''

        if (!resJSON.data) {
            res.txtFinish = res.finish = true
            return res
        }

        const innerData = resJSON.data.data
        const ttsData = innerData ?? resJSON.data
        const isCallService = res.intention === EAiAgentType.CALL_SERVICE
        const isCallServiceEnd = isCallService && resJSON.data.role === '专属客服'

        res.txtFinish = isCallService
            ? ttsData.ttsFinish ?? res.txtFinish
            : ttsData.ttsFinish
        res.finish = isCallServiceEnd || !ttsData.ttsPlay

        // 特殊处理专属客服情况【暂定】
        if (res.intention === EAiAgentType.HUMAN_SERVICE) {
            res.result = HUMAN_SERVICE_REPLY
            return res
        }

        if (isCallService) {
            if (res.finish) {
                res.result = HUMAN_SERVICE_REPLY
            }

            dataIndex++
            continue
        }

        if (!res.txtFinish) {
            res.result += (resJSON.data.tts ?? '')
        } else if (res.intention === EAiAgentType.SALES_ASSISTANT && res.finish) {
            // 商品数据
            const COM = (resJSON as ISaleAssistantRes).data.items ?? []
            COM.forEach(com => {
                const { id, name, price, url, category } = com
                res.commodity.push({ id, name, price, url, category })
            })
        }

        dataIndex++
    }

    return res
}